import Logo from "@/components/Logo";

export default function MobileLogoHeader() {
  return (
    <Logo withIcon={true} className="md:hidden justify-center pt-4 mb-1" />
  );
}
